import { Component, h, Host, Element, forceUpdate, Prop, Listen } from '@stencil/core';

/**
 * The `pn-accordion` is a wrapper for `pn-accordion-row` components.
 * This component gives the accordion rows some space between each one and provides the `single` feature.
 * Which will force the rule that only a single row to be open at one time.
 */
@Component({
  tag: 'pn-accordion',
  styleUrl: 'pn-accordion.scss',
})
export class PnAccordion {
  mo?: MutationObserver;

  closeEvent = new CustomEvent('rowstate', { detail: false });

  @Element() hostElement: HTMLElement;

  /** Only allow a single row to be open at once. */
  @Prop() single: boolean = false;
  /** Optional prop that removes the default white background on the accordion row */
  @Prop() transparent: boolean = false;

  connectedCallback() {
    this.mo = new MutationObserver(() => forceUpdate(this.hostElement));

    this.mo.observe(this.hostElement, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.mo.disconnect();
  }

  @Listen('togglerow')
  handleSingleRow({ detail }) {
    if (!this.single) return;

    const element: HTMLDetailsElement = detail.element;
    const activeRow = element.closest('pn-accordion-row');

    const rows = Array.from(this.hostElement.querySelectorAll('pn-accordion-row'));

    rows.forEach(row => !row.isSameNode(activeRow) && row.dispatchEvent(this.closeEvent));
  }
  render() {
    return (
      <Host class="pn-accordion" data-transparent={this.transparent}>
        <slot />
      </Host>
    );
  }
}
